var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 602,
    viewBox: "0 0 602 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.989 601.974C467.221 601.974 601.979 467.216 601.979 300.984C601.979 134.753 467.221 -0.00488281 300.989 -0.00488281C134.758 -0.00488281 0 134.753 0 300.984C0 467.216 134.758 601.974 300.989 601.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.827 325.204V449.296H408.883V333.521C408.883 304.451 398.495 284.599 372.446 284.599C352.567 284.599 340.758 297.964 335.543 310.905C333.649 315.53 333.16 321.953 333.16 328.44V449.29H261.21C261.21 449.29 262.176 253.206 261.21 232.908H333.166V263.572C333.021 263.813 332.817 264.049 332.688 264.28H333.166V263.572C342.727 248.86 359.778 227.827 398.007 227.827C445.341 227.827 480.827 258.753 480.827 325.204ZM185.944 128.604C161.333 128.604 145.231 144.76 145.231 165.985C145.231 186.76 160.866 203.382 185 203.382H185.466C210.561 203.382 226.163 186.76 226.163 165.985C225.686 144.76 210.561 128.604 185.944 128.604ZM149.507 449.296H221.431V232.908H149.507V449.296Z",
    fill: "#172130"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 601.979,
    height: 601.979,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b7829c5f08dd55c8b8a3806ffaa2501e.svg";
export { ForwardRef as ReactComponent };